export default __webpack_public_path__ + "static/media/Calendar.0ce9c713.svg";